<template>
    <div class="main-content">
        <div class="uk-padding">
            <ul class="uk-breadcrumb">
                <li><router-link to="/blog">Blog</router-link></li>
                <li><router-link :to="{ name: 'EditBlogPost', params: { id: $route.params.id }}">Blog {{editing ? 'bewerken' : 'maken'}}</router-link></li>
            </ul>
            <h1>{{blog.title}}</h1>
            <div>
                <form>
                    <fieldset class="uk-fieldset">
                        <div class="uk-margin">
                            <input class="uk-input" v-model="blog.title" type="text" placeholder="Blog Titel">
                        </div>
                        <div class="uk-margin">
                            <input class="uk-input uk-checkbox" type="checkbox" v-model="blog.online" placeholder="Beschikbaar" />
                            <label>Openbaar</label>
                        </div>
                        <div class="uk-margin">
                            <select class="uk-select uk-form-width-medium" v-model="newCategory">
                                <option :value="key" v-for="(c, key) in categories">{{c}}</option>
                            </select>
                            <button @click.prevent="addCategory" class="uk-button uk-button-secondary">toevoegen</button>
                        </div>
                        <div class="uk-margin" v-if="Object.keys(blog.categories).length > 0">
                            <div class="uk-column-span" v-for="(c, k) in blog.categories">
                                <p class="uk-align-left">{{c}}</p>
                                <button class="uk-align-right uk-label uk-label-danger" @click.prevent="removeCategory(k)"><span uk-icon="trash"></span></button>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <Vueditor ref="editor"></Vueditor>
                        </div>
                        <image-picker class="uk-margin-bottom" @choose="choose"></image-picker>
                         <div class="uk-child-width-1-4@m" uk-grid>
                            <div v-for="(g, i) in blog.gallery" >
                                <div class="uk-card uk-card-default">
                                    <div class="uk-card-media-top">
                                        <img :src="g.url" alt="">
                                    </div>
                                    <div>
                                        <p>{{g.description}}</p>
                                    </div>
                                    <button class="uk-card-badge uk-label uk-label-danger" @click.prevent="removeImage(i)"><span uk-icon="trash"></span></button>
                                </div>
                            </div>
                        </div>
                        <button class="uk-button uk-button-primary uk-align-right" type="submit" @click.prevent="update">{{editing ? 'updaten' : 'toevoegen'}}</button>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
var moment = require('moment');
import {db} from '@/CUSTOM/helpers/firebase'
import firebase from 'firebase'
import imageUploader from '@/CORE/modules/MEDIA/ImageUploader'
import imagePicker from '@/CORE/modules/MEDIA/imagePicker'
import Vue from 'vue'
export default {
    name: 'EditBlogPost',
    components: {imageUploader, imagePicker},
    data () {
        return {
            categories: null,
            blog: {
                title: null,
                content: '',
                categories: [],
                gallery: []
            },
            newCategory: null,
            editing: false
        }
    },
    created () {
        db.collection('categories').doc('all').get().then(doc => {
            this.categories = doc.data()
        }).catch(error => {
            console.log(error)
        })
    },
    mounted(){
        this.$refs.editor.setContent(this.blog.content);
        if(this.$route.params.id != 0) {
            this.editing = true
             db.collection('blogposts').doc(this.$route.params.id).onSnapshot((snap) => {
                this.blog = snap.data()
                this.$refs.editor.setContent(this.blog.content);
            })
        }
       
    },
    methods: {
        update () {
            this.blog.lastEdit = firebase.firestore.FieldValue.serverTimestamp() || Math.floor(Date.now() / 1000)
            this.blog.content = this.$refs.editor.getContent();
            if(this.$route.params.id == 0) {
                this.blog.author = {
                    name: this.$store.state.core.user.displayName,
                    photoURL: this.$store.state.core.user.photoURL || ''
                }
                this.blog.created = firebase.firestore.FieldValue.serverTimestamp() || Math.floor(Date.now() / 1000)
                db.collection('blogposts').doc(this.blog.title.toLowerCase().split(' ').join('-')).set(this.blog, {merge: true}).then(r => {
                    this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Blogpost toegevoegd', status: 'success'})
                    this.$router.push('/blog')
                })
            } else {
                db.collection('blogposts').doc(this.$route.params.id).update(this.blog).then(r => {
                    this.$store.dispatch('PUSH_NOTIFICATION', {message: 'Blogpost aangepast', status: 'success'})
                    this.$router.push('/blog')
                })
            }
        },
        convertDate (timestamp) {
            return moment.unix(timestamp).fromNow();
        },
        uploaded (files) {
            files.forEach(f => {
                this.blog.gallery.push({text: null, file: f, cover: false})
            })
        },
        removeImage(i) {
            this.blog.gallery.splice(i, 1);
        },
        addCategory () {
            this.blog.categories.push(this.categories[this.newCategory])
        },
        removeCategory(key) {
            this.blog.categories.splice(key, 1)
        },
        choose (images) {
            for(var i in images) {
                var img = images[i]
                this.blog.gallery.push({key: i, description: img.description, url: img.url, medium: img.medium, large: img.large, extralarge: img.extralarge, small: img.small, cover: false, placeholder: img.placeholder, alt: img.alt, title: img.title})
            }
        }
    }
}
</script>
<style>
.vueditor {
    min-height: 300px;
}
</style>


// WEBPACK FOOTER //
// EditBlogPost.vue?4329c468